import { Component, OnInit } from '@angular/core';
import { HttpService, CoreService, } from '../../../services';
import { TemplateModel, ConfigKey } from '../../../models';

@Component({
  templateUrl: './PersonneImageTemplate.component.html',
  styleUrls: ['./PersonneImageTemplate.component.css']
})

//!\\ ne pas oublier de declarer le composent dans le template.module.ts et index.ts //!\\
export class PersonneImageTemplateComponent implements OnInit {

  // Info de base du template qui utilisé lors de la sélection du template dans la page d'adminBo
  __TemplateInfo(): any {
    return {
      // Nom d'affichage du Template
      name: `Image profil`,
      // Info supplémentaire du template
      toolTips: `image de profil de l'utilisateur`,
      // Liste des tables où le template sera utilisable
      // ex: ['tBOGROUPE'] le template sera utilisable uniquement sur les bo de la table tBoGroupe)
      // ex 2: ['ALL'] le tempalte sera utilisable sur toutes les table 
      table: ['tDOPersonne', 'tDOClient']
    };
  }

  // Donnée relative au BO
  tpl: TemplateModel;

  constructor(
    protected indParam: CoreService,
    protected template: TemplateModel,
    protected http: HttpService) {
    this.tpl = template;
  }
  imgName: string;
  imgUrl: string;
  type: string;
  loaded: boolean = false;

  linkFacebook: string;
  linkTwitter: string;
  linkLinkedIn: string;
  linkViadeo: string;

  ngOnInit() {
    this.tpl.Mode = 'IMAGEPROFIL';
    this.http.postHttp<TemplateModel>(`${this.indParam.AppParams.apiUrl}api/boTemplate/`, this.tpl).subscribe((data: TemplateModel) => {
      if (!data.HasError) {
        this.imgName = data.QueryReturn['imgName']
        this.imgUrl = `${this.indParam.getConfigKey(ConfigKey.IMGHTTP)}Images/${this.indParam.AppParams.dbname}/${data.QueryReturn['imgName']}`;
        this.type = data.QueryReturn['type'];



        this.linkFacebook = data.QueryReturn['linkFacebook']
        this.linkTwitter = data.QueryReturn['linkTwitter']
        this.linkLinkedIn = data.QueryReturn['linkLinkedIn']
        this.linkViadeo = data.QueryReturn['linkViadeo']


        this.loaded = true;
      }
    });
  }

}
